import type { AccessResource } from '@web/types'
import type { ViewProps } from '@kit/ui'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type PopoverLinks = {
  id: AccessResource['id']
}
export type LayoutState = {
  loading: boolean
  popoverLinks: PopoverLinks
  routeLayoutProps: ViewProps
}

const initialState: LayoutState = {
  loading: false,
  popoverLinks: {
    id: '',
  },
  routeLayoutProps: {},
}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setActiveHeaderLink: (state, action) => {
      state.popoverLinks.id = action.payload
    },
    setRouteLayoutProps: (state, { payload }: PayloadAction<Partial<ViewProps>>) => {
      state.routeLayoutProps = payload as any
    },
    mergeRouteLayoutProps: (state, { payload }: PayloadAction<Partial<ViewProps>>) => {
      state.routeLayoutProps = { ...state.routeLayoutProps, ...payload } as any
    },
    resetRouteLayoutProps: (state) => {
      state.routeLayoutProps = initialState.routeLayoutProps as any
    },
  },
  selectors: {
    popoverLinks: (state) => state.popoverLinks,
    routeLayoutProps: (state) => state.routeLayoutProps,
  },
})

export const layoutActions = layoutSlice.actions
export const layoutSelectors = layoutSlice.selectors

const reducerPath = layoutSlice.reducerPath
export const layoutReducer = {
  [reducerPath]: layoutSlice.reducer,
}
